/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Customer_Already_LinkedInputs */

const vi_error_shop_customer_already_linked = /** @type {(inputs: Error_Shop_Customer_Already_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khách hàng này đã gắn với một tài khoản online khác. Mỗi khách chỉ có một tài khoản online.`)
};

/**

* @param {Error_Shop_Customer_Already_LinkedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_customer_already_linked = /** @type {((inputs?: Error_Shop_Customer_Already_LinkedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Customer_Already_LinkedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_customer_already_linked(inputs)
});